@use "@styles/component-mixins" as component;

@layer base-components {
    .overflow {
        display: inline-flex;
    }

    // Not inline: an inline trigger takes the parent's line height and drops
    // the chip below the stack.
    .chip {
        display: inline-flex;
    }

    .hiddenText {
        @include component.visually-hidden;
    }
}
